import React from 'react';
import { Link } from 'react-router-dom';

import { SearchAlienationRecuperationEtatBienWarningDto } from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';

import { FluxDisplayName } from '../../../../../../../enums/flux/FluxDisplayName';
import DashboardWarningsAlienation from '../../../shared/components/DashboardWarningsAlienation';

import '../../../../css/DashboardWarnings.less';

function DashboardWarningsVenteDossier(): React.ReactElement {
  function buildDossierLink(
    data: SearchAlienationRecuperationEtatBienWarningDto,
  ): React.ReactElement {
    return (
      <Link to={`/admin/dossier/${data.dossierId}`} className={'dossierLink'}>
        {data.dossierId}
      </Link>
    );
  }

  function buildAdditionalColumns(): ColumnProps<SearchAlienationRecuperationEtatBienWarningDto>[] {
    return [
      {
        title: 'Id dossier',
        buildCellContent: data => buildDossierLink(data),
      },
      {
        title: 'Id Hermès',
        buildCellContent: data => data.alienationId,
      },
    ];
  }
  return (
    <DashboardWarningsAlienation
      getControllerFunctionFetchFlux={controller =>
        controller.searchSpecificFluxEtatBienUsingGET.bind(controller)
      }
      getControllerFunctionFetchWarnings={controller =>
        controller.searchWarningsOfFluxEtatBienUsingGET.bind(controller)
      }
      buildSpecificTableColumns={buildAdditionalColumns}
      tableTitle={FluxDisplayName.ALIENATION_ETAT_BIENS}
    />
  );
}

export default DashboardWarningsVenteDossier;
